interface ScentdLogoProps {
  size?: number;
  className?: string;
}

export default function ScentdLogo({ size = 48, className = '' }: ScentdLogoProps) {
  const r = size * 0.22;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Scentd"
    >
      <rect width="100" height="100" rx="22" ry="22" fill="#B5A48A" />
      <text
        x="50"
        y="74"
        textAnchor="middle"
        fontFamily="'Playfair Display', Georgia, serif"
        fontWeight="400"
        fontSize="72"
        fill="#FAF7F2"
      >
        S
      </text>
    </svg>
  );
}
